import { render } from "./PolicyReview.vue?vue&type=template&id=6e8899d1&scoped=true"
import script from "./PolicyReview.vue?vue&type=script&lang=js"
export * from "./PolicyReview.vue?vue&type=script&lang=js"

import "./PolicyReview.vue?vue&type=style&index=0&id=6e8899d1&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e8899d1"]])

export default __exports__